module.exports = __webpack_public_path__ + "static/media/sequelize.85056624.png";